import React, { Component } from 'react';
import { auth } from './firebase/firebaseconfig'


class Forgetpass extends Component {

    constructor(props){
        super(props)
        this.state={   
            show_f:false,         
            email:this.props.props.email,
            ErrorMessage:'',
            
                       
        }
        // this.myRef_f = React.createRef();
        // this.msgRef_f= React.createRef();

       
    }

    close=event=>{
        this.setState({email:"",show_f:false,status:"",ErrorMessage:""})
    }

    handleSubmit = async event => {
        
        const page = this
        event.preventDefault()
        page.setState({ isLoading: true })
        try {
            // var auth = firebase.auth();
            var emailAddress = this.state.email;

            auth.sendPasswordResetEmail(emailAddress).then(function() {
                // alert("Password update link is sent to your email. Please update it & loggin again.")
                // Swal('Uploaded', 'Your file have been uploaded', 'success');
                // this.myRef_f.current.style.visibility = "visible";
                page.setState({email:"",show_f:true,status:"success",ErrorMessage: 'Password update link is sent to your email. Please update it & loggin again.'})
            // Email sent.
            }).catch(function(error) {
                // alert("Some error while sending the link")
                page.setState({show_f:true,status:"error",ErrorMessage:"Some error while sending the link" })
            // An error happened.
            });
            // window.location.href = '/';
        
        } catch (e) {
            console.log(e)
            this.setState({
                ErrorMessage: 'Incorrect username or password.'
                ,status:"error"
            });
            page.setState({ isLoading: false })
            
        }
    }
    

    handleCancel(){
        window.location.href = '/';
    }

    handleChange = event => {
        const page = this
        page.setState({
            email: event.target.value
        })
    }

    render() {
        return (
            <div className="login-form login-forgot">
                        <div className="text-center mb-10 mb-lg-20">
                            <h3 className="font-size-h1">Forgotten Password ?</h3>
                            <p className="text-muted font-weight-bold">Enter your email to reset your password</p>
                        </div>
                        
                        <form className="form" id="kt_login_forgot_form">
                            <div className="form-group">
                                {/* <input className="form-control form-control-solid h-auto py-5 px-6" onChange={this.handleChange}
                                 type="email" placeholder="Email" name="email" autocomplete="off" /> */}
                                 <input className="form-control form-control-solid h-auto py-5 px-6" type="email" 
                                value={this.state.email} onChange={this.handleChange} id="email"
                                placeholder="Email" name="username" autocomplete="off" />
                            </div>
                            <div className="form-group d-flex flex-wrap flex-center">
                                <button type="button" id="kt_login_forgot_submit" onClick={this.handleSubmit}
                                className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4">Submit</button>
                                <button type="button" id="kt_login_forgot_cancel" 
                                className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
                                onClick={()=>this.handleCancel()}
                                >Cancel</button>
                            </div>
                        </form>
                        <div className={this.state.show_f==true?"swal2-container swal2-center swal2-backdrop-show":"d-none"}>
   <div aria-labelledby="swal2-title" aria-describedby="swal2-content" class="swal2-popup swal2-modal swal2-icon-error swal2-show" tabindex="-1" role="dialog" aria-live="assertive" aria-modal="true" style={{display: "flex"}}>
      <div class="swal2-header">
         {this.state.status=="error"?
         <div class="swal2-icon swal2-error swal2-icon-show" style={{display: "flex"}}><span class="swal2-x-mark">
            <span class="swal2-x-mark-line-left"></span>
            <span class="swal2-x-mark-line-right"></span>
            </span>
         </div>
         :
         <div class="swal2-icon swal2-success swal2-icon-show" style={{display: "flex"}}><div class="swal2-success-circular-line-left" ></div>
      <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
      <div class="swal2-success-ring"></div> <div class="swal2-success-fix" ></div>
      <div class="swal2-success-circular-line-right" ></div>
    </div>
    }
      </div>
      <div class="swal2-content">
         <div id="swal2-content" class="swal2-html-container" style={{display: "block"}} >{this.state.ErrorMessage}</div>
         
         <div class="swal2-validation-message" id="swal2-validation-message"></div>
      </div>
      <div class="swal2-actions"><button type="button" class="swal2-confirm btn font-weight-bold btn-light-primary" aria-label="" style={{display: "inline-block"}}  onClick={this.close}>Ok, got it!</button><button type="button" class="swal2-cancel" aria-label="" style={{display: "none"}}>Cancel</button></div>
      <div class="swal2-footer" style={{display: "none"}}></div>
      <div class="swal2-timer-progress-bar-container">
         <div class="swal2-timer-progress-bar" style={{display: "none"}}></div>
      </div>
   </div>
</div>
                    </div>
            );
    	    }
     }
     export default Forgetpass;